import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const EmailIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path stroke="currentColor" d="m21 6-9 6-9-6" />
            <path
                stroke="currentColor"
                d="M20.674 5.501H3.326c-.456 0-.826.277-.826.619v11.762c0 .342.37.619.826.619h17.348c.456 0 .826-.277.826-.62V6.12c0-.342-.37-.619-.826-.619Z"
            />
        </svg>
    </IconWrapper>
)
